export const SET_LOADING = 'application/SET_LOADING';
export const SET_READY = 'application/SET_READY';
export const SET_CURRENT_STEP = 'application/SET_CURRENT_STEP';
export const SET_LANGUAGE = 'application/SET_LANGUAGE';
export const SET_SUCCESS = 'application/SET_SUCCESS';
export const SET_DEFAULT_LANGUAGE = 'application/SET_DEFAULT_LANGUAGE';
export const SET_CONNECTED_PROPERTY = 'application/SET_CONNECTED_PROPERTY';
export const SET_UNKNOWN_PROPERTY = 'application/SET_UNKNOWN_PROPERTY';
export const SET_WIDGET = 'application/SET_WIDGET';
